<template>
  <v-container fluid grid-list-md py1>
    <v-layout row wrap class="mb-4">
      <v-flex md12>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.seguridad.usuario.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-fade-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <v-form @keyup.ctrl.83="executeValidators">
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <!-- Username -->
                      <v-text-field
                        v-model="$v.usuario.username.$model"
                        maxlength="20"
                        class="allmin"
                        :disabled="view.elem.input.username.disabled"
                        :error-messages="getFirstErrorDescription($v.usuario.username)"
                        :label="$t('view.seguridad.usuario.form.username.label')" />

                      <!-- Nombre -->
                      <v-text-field
                        v-model="$v.usuario.nombre.$model"
                        :disabled="view.action.submit.busy"
                        maxlength="50"
                        :error-messages="getFirstErrorDescription($v.usuario.nombre)"
                        :label="$t('view.seguridad.usuario.form.nombre.label')" />

                      <!-- Telefono -->
                      <v-text-field
                        v-model="$v.usuario.telefono.$model"
                        :disabled="view.action.submit.busy"
                        maxlength="80"
                        :error-messages="getFirstErrorDescription($v.usuario.telefono)"
                        :label="$t('view.seguridad.usuario.form.telefono.label')" />

                      <!-- Interno -->
                      <v-text-field
                        v-model="$v.usuario.interno.$model"
                        :disabled="view.action.submit.busy"
                        maxlength="80"
                        :error-messages="getFirstErrorDescription($v.usuario.interno)"
                        :label="$t('view.seguridad.usuario.form.interno.label')" />

                      <!-- Celular -->
                      <v-text-field
                        v-model="$v.usuario.celular.$model"
                        :disabled="view.action.submit.busy"
                        maxlength="80"
                        :error-messages="getFirstErrorDescription($v.usuario.celular)"
                        :label="$t('view.seguridad.usuario.form.celular.label')" />

                      <!-- Correo Electronico -->
                      <v-text-field
                        v-model="$v.usuario.correoElectronico.$model"
                        :disabled="view.action.submit.busy"
                        maxlength="80"
                        :error-messages="getFirstErrorDescription($v.usuario.correoElectronico)"
                        :label="$t('view.seguridad.usuario.form.correoElectronico.label')" />
                    </v-flex>

                    <v-flex xs12 md6 class="croppa_flex">
                      <!-- Foto -->
                      <croppa
                        v-model="croppa"
                        :new-image-drawn="renderImage()"
                        :initial-image="usuario.foto"
                        :zoom-speed="3"
                        class="userdp"
                        :width="150"
                        :height="150"
                        :placeholder="$t('view.commons.imgsel')"
                        placeholder-color="#000"
                        :placeholder-font-size="10"
                        canvas-color="transparent"
                        :show-loading="true"
                        :loading-size="25"
                        loading-color="#606060"
                        initial-position="center"
                        initial-size="cover"
                        :show-remove-button="false"
                        :prevent-white-space="true"
                        @move="renderImageChange"
                        @zoom="renderImageChange" />
                      <v-btn
                        v-if="usuario.foto"
                        fab
                        outlined
                        width="30"
                        height="30"
                        color="primary"
                        class="btn_tippy ml-2"
                        elevation="0"
                        :title="$t('view.commons.imgrem')"
                        @click="croppaRemove()">
                        <em class="fas fa-times" />
                      </v-btn>
                    </v-flex>

                    <v-flex xs12 md6>
                      <v-layout row wrap>
                        <!-- Enabled -->
                        <v-flex class="form-group" xs12 md6>
                          <label class="v-label mt-3" for="status">{{ $t("view.commons.status") }}</label>
                          <v-switch v-model="usuario.enabled" input-value="true" color="primary" disabled />
                        </v-flex>

                        <!-- Activo -->
                        <v-flex class="form-group" xs12 md6>
                          <label class="v-label mt-3" for="activo">{{ $t("view.seguridad.usuario.form.activo.label") }}</label>
                          <v-switch v-model="usuario.activo" input-value="true" color="primary" disabled />
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 md12>
                      <label class="v-label mt-3" for="tipo">{{ $t("view.seguridad.usuario.form.tipoUsuario.label") }}</label>
                      <v-btn-toggle v-model="usuario.tipoUsuario" rounded mandatory group @change="(event) => onChangeTipoUsuario(event)">
                        <v-btn value="ADMINISTRADOR">
                          {{ $t("view.seguridad.usuario.form.tipoUsuario.administrador.label") }}
                        </v-btn>
                        <v-btn value="VENDOR">
                          {{ $t("view.seguridad.usuario.form.tipoUsuario.vendor.label") }}
                        </v-btn>
                        <v-btn value="REP">
                          {{ $t("view.seguridad.usuario.form.tipoUsuario.rep.label") }}
                        </v-btn>
                      </v-btn-toggle>
                    </v-flex>
                    <v-flex xs12 md12>
                      <v-autocomplete
                        v-if="usuario.tipoUsuario == 'VENDOR'"
                        v-model.trim="usuario.idVendor"
                        :label="$t('view.seguridad.usuario.form.idVendor.label')"
                        :items="view.elem.select.vendor.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        :rules="ruleIdVendor"
                        @input="search = ''" />

                      <v-autocomplete
                        v-if="usuario.tipoUsuario == 'REP'"
                        v-model.trim="usuario.idRep"
                        :label="$t('view.seguridad.usuario.form.idRep.label')"
                        :items="view.elem.select.rep.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        :rules="ruleIdRep"
                        @input="search = ''" />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-show="fechaalta && $userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.seguridad.perfil.title')"
                    :loading="view.action.submit.busy"
                    @click="loadPerfiles(usuario.username, usuario.nombre)">
                    <v-icon small>mdi mdi-account-plus</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="fechaalta && $userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.enabled.title.current"
                    :loading="view.action.submit.busy"
                    @click="enabledUser()">
                    <v-icon small>{{ view.elem.button.enabled.class.current }}</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="fechaalta && $userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.login.resetPwd.title')"
                    :loading="view.action.submit.busy"
                    @click="resetPassword()">
                    <v-icon small>vpn_key</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="fechaalta && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="$userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-fade-transition>
        </v-card>
      </v-flex>
    </v-layout>

    <data-table ref="usuarioTable" @editRow="load" @auditRow="audit" @showPerfiles="loadPerfiles" />

    <auditoria ref="auditModal" />

    <perfilesModal ref="PerfilesModal" />
  </v-container>
</template>

<script>
import usuarioStates from "@/views/seguridad/usuario/usuario-states"; /** *******************************/
import UsuarioAPI from "@/services/seguridad/usuario"; /** *******************************/
import DataTable from "@/views/seguridad/usuario/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import PerfilesModal from "@/views/seguridad/usuario/PerfilesModal"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required, email } from "vuelidate/lib/validators";
import { alphaNumDot } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse, getResponseDTO } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { resetPasswordSwal } from "@/constants/sweet-alerts";
import { submit, enabled } from "@/constants/buttons";
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";

const action = { submit: { busy: false } };

const input = { username: { disabled: true } };

let select = {
  comercios: {
    options: [
      {
        name: ""
        , code: ""
      }
    ]
  }
  , vendor: {
    completeList: []
    , filteredList: []
  }
  , rep: {
    completeList: []
    , filteredList: []
  }
};

export default {
  name: "UsuarioModule"
  , components: {
    DataTable
    , Auditoria
    , PerfilesModal
  }
  , data() {
    return {
      locale: this.$store.language
      , usuario: undefined
      , perfiles: []
      , fechaalta: null
      , state: new Object()
      , search: ""
      , view: {
        title: "Usuario"
        , action
        , elem: {
          button: {
            submit
            , enabled
          }
          , select
          , input
          , showForm: true
        }
      }
      , ruleIdVendor: [
        (value) => {
          if (this.usuario.tipoUsuario == "VENDOR" && (value == null || value <= 0)) {
            return this.$t("view.seguridad.usuario.rules.idVendor");
          }
          return true;
        }
      ]
      , ruleIdRep: [
        (value) => {
          if (this.usuario.tipoUsuario == "REP" && (value == null || value <= 0)) {
            return this.$t("view.seguridad.usuario.rules.idRep");
          }
          return true;
        }
      ]
      , croppa: {}
      , croppainput: false
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , async created() {
    this.form = new usuarioStates(this);
    this.form.$setState("initial");
    this.$nextTick(() => this.loadSelectsData());
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.usuario);
        if (respuesta) {
          const responseDTO = getResponseDTO(respuesta);
          if (handleResponse(respuesta, this.$t("view.seguridad.usuario.errors"))) {
            this.load(responseDTO.usuario.username);
          }
        }
      } catch (error) {
        handleResponse(error, this.$t("view.seguridad.usuario.errors"));
      }
    }
    , async load(username) {
      this.croppa.remove();
      const response = await UsuarioAPI.get({ username });
      if (response != null) {
        const { data: { results: { usuario } } } = response;
        this.fechaalta = usuario.fechaalta;
        this.form.$setState("editing", usuario);
      }
    }
    , async loadSelectsData() {
      const { data: { results: { combo: responseVendorList } } } = await CombosAPI.get({ option: "vendor" });
      this.view.elem.select.vendor.filteredList = responseVendorList ? responseVendorList.filter((value) => value.status) : [];
      this.view.elem.select.vendor.completeList = responseVendorList || [];

      const { data: { results: { combo: responseRepList } } } = await CombosAPI.get({ option: "rep" });
      this.view.elem.select.rep.filteredList = responseRepList ? responseRepList.filter((value) => value.status) : [];
      this.view.elem.select.rep.completeList = responseRepList || [];

      this.refreshkey += 1;
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.usuario.username, dataDescripcion = this.usuario.nombre) {
      this.$refs.auditModal.loadAudit(clave, "Users", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
    , async resetPassword() {
      if ((await this.$swal(resetPasswordSwal)).value) {
        const respuesta = await UsuarioAPI.resetPassword(this.usuario.username);
        handleResponse(respuesta, this.$t("view.seguridad.usuario.errors"));
      }
    }
    , async enabledUser() {
      const enabled = !this.usuario.enabled;
      const username = this.usuario.username;
      const respuesta = await UsuarioAPI.updateStatus({ username, enabled });
      if (handleResponse(respuesta, this.$t("view.seguridad.usuario.errors"))) {
        this.$refs.usuarioTable.refreshData();
        const { data: { results: { usuario } } } = respuesta;
        this.form.$setState("editing", usuario);
      }
    }
    , renderImage() {
      if (this.croppainput && this.croppa && this.croppa.hasImage) {
        this.usuario.foto = this.croppa.generateDataUrl();
        this.usuario.fotoMiniatura = this.croppa.generateDataUrl("image/jpeg", 0.5);
        this.croppainput = this.usuario.foto.length == 0;
      }
    }
    , renderImageChange() {
      if (this.croppa && this.croppa.hasImage) {
        this.usuario.foto = this.croppa.generateDataUrl();
        this.usuario.fotoMiniatura = this.croppa.generateDataUrl("image/jpeg", 0.5);
      }
    }
    , croppaRemove() {
      this.usuario.foto = "";
      this.usuario.fotoMiniatura = "";
      this.croppa.remove();
      this.croppainput = true;
      setTimeout(() => document.body.click(), 100);
    }
    , async loadPerfiles(username, nombre) {
      this.$refs.PerfilesModal.loadPerfiles(username, nombre);
    }
    , async getVendorList() {
      const { data: { results: { combo: responseVendorList } } } = await CombosAPI.get({ option: "vendor" });
      return responseVendorList;
    }
    , async getRepList() {
      const { data: { results: { combo: responseRepList } } } = await CombosAPI.get({ option: "rep" });
      return responseRepList;
    }
    , onChangeTipoUsuario(value) {
      if (value != "VENDOR") {
        this.usuario.idVendor = null;
      }
      if (value != "REP") {
        this.usuario.idRep = null;
      }
    }
  }
  , validations: {
    usuario: {
      username: {
        required
        , alphaNumDot
      }
      , nombre: { required }
      , telefono: {}
      , interno: {}
      , celular: {}
      , correoElectronico: {
        required
        , email
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.croppa_flex {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 30px !important;
  max-height: 160px !important;
}
.userdp {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/seguridad/usuario/Usuario.vue